import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import { Link } from 'dibs-elements/exports/Link';
import classnames from 'classnames';
import {
    getTradeBuyerProtectionDuration,
    getTradeBuyerProtectionTier,
    getTradeUserRewardsProgramInfo,
} from '../helpers/tradeBuyerProtectionHelper';
import styles from './PdpSharedBuyerProtectionBox.scss';

export const PdpSharedBuyerProtectionBoxComponent = ({ user }) => {
    const readMoreHref = user?.isVerifiedTrade ? '/info/trade/promise/' : '/about/promise/';
    const {
        tradeProtectionTierCode,
        tradeProtectionDurationCode,
        showTradeRewardsCopy,
    } = getTradeUserRewardsProgramInfo(user);

    return (
        <div className={styles.wrapper} data-tn="buyer-protection-wrrapper">
            <div className={styles.copy}>
                <div className={styles.title} data-tn="buyer-protection-title">
                    <FormattedMessage
                        id="PdpSharedBuyerProtectionBox.title"
                        defaultMessage="1stDibs Buyer Protection Guaranteed"
                    />
                </div>
                <div
                    className={classnames(styles.message, {
                        [styles.tradeRewardsMessage]: showTradeRewardsCopy,
                    })}
                    data-tn="buyer-protection-message"
                >
                    {' '}
                    {showTradeRewardsCopy ? (
                        <FormattedMessage
                            id="PdpSharedBuyerProtectionBox.tradeRewardsMessage"
                            defaultMessage="If your item arrives not as described, we’ll work with you and the seller to make it right. As a {tier}, you get {days} to report any issues you have with the order."
                            values={{
                                tier: (
                                    <span className={styles.messageBold}>
                                        {getTradeBuyerProtectionTier(tradeProtectionTierCode)}
                                    </span>
                                ),
                                days: (
                                    <span className={styles.messageBold}>
                                        {getTradeBuyerProtectionDuration(
                                            tradeProtectionDurationCode
                                        )}
                                    </span>
                                ),
                            }}
                        />
                    ) : (
                        <FormattedMessage
                            id="PdpSharedBuyerProtectionBox.message"
                            defaultMessage="If your item arrives not as described, we’ll work with you and the seller to make it right."
                        />
                    )}{' '}
                    <Link
                        href={readMoreHref}
                        ariaLabel={
                            <FormattedMessage
                                id="PdpSharedBuyerProtectionBox.readMoreLinkA11y"
                                defaultMessage="Learn more about buyer protection"
                            />
                        }
                        target="_blank"
                        dataTn="buyer-protection-link"
                    >
                        <FormattedMessage
                            id="PdpSharedBuyerProtectionBox.readMoreLink"
                            defaultMessage="Learn more"
                        />
                    </Link>
                </div>
            </div>
        </div>
    );
};

PdpSharedBuyerProtectionBoxComponent.propTypes = {
    user: PropTypes.object,
};

export const PdpSharedBuyerProtectionBox = createFragmentContainer(
    PdpSharedBuyerProtectionBoxComponent,
    {
        user: graphql`
            fragment PdpSharedBuyerProtectionBox_user on User {
                isVerifiedTrade
                tradeFirm @include(if: $isTrade) {
                    rewards {
                        currentProgram {
                            programInfo {
                                code
                            }
                            childPrograms(filter: "ENHANCED_BUYER_PROTECTION") {
                                code
                            }
                        }
                    }
                }
            }
        `,
    }
);
